import { render } from "./AboutEPClubCard.vue?vue&type=template&id=3c37b2ef"
import script from "./AboutEPClubCard.vue?vue&type=script&lang=js"
export * from "./AboutEPClubCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__